import React from "react";
import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import "../css/ReserveAcknowledgementDialog.css";
import letsDoItIcon from "../../assets/images/lets-do-it-icon.svg";
import acknowledgementStarIcon from "../../assets/images/acknowledgement-star-icon.svg";
import {
  formatDateString,
  getWorkspaceSlotDuration,
  getWorkspaceSlotTime,
} from "utils/utils";
import { MEETING_ROOM_TYPE } from "utils/constants";

interface ReserveAcknowledgementDialogProps {
  open: boolean;
  onClose: () => void;
  slotData: any;
  seaterPreference?: string;
  onClickLetsDo?: () => void;
  isLoading?: boolean;
}

const ReserveAcknowledgementDialog: React.FC<
  ReserveAcknowledgementDialogProps
> = ({
  open,
  onClose,
  slotData,
  seaterPreference,
  onClickLetsDo,
  isLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "reserve-acknowledgement-dialog-container",
      }}
      BackdropProps={{
        className: "reserve-acknowledgement-dialog-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="reserve-acknowledgement-dialog-header">
          Acknowledgement
        </div>
        <div className="reserve-acknowledgement-dialog-header-title">
          Confirm your spot for
        </div>
        <div className="reserve-acknowledgement-dialog-containt-container">
          <div className="note">Note:</div>
          <div>
            <img
              src={acknowledgementStarIcon}
              alt="lets-do-it-logo"
              className="note-image"
            />
            <span className="note-label">Duration:</span>
            <span className="note-value">
              {" "}
              {getWorkspaceSlotDuration(
                slotData?.start_time,
                slotData?.end_time,
              )}
            </span>
          </div>
          <div>
            <img
              src={acknowledgementStarIcon}
              alt="lets-do-it-logo"
              className="note-image"
            />
            <span className="note-label">Date:</span>
            <span className="note-value">
              {" "}
              {formatDateString(slotData?.start_time)}
            </span>
          </div>
          <div>
            <img
              src={acknowledgementStarIcon}
              alt="lets-do-it-logo"
              className="note-image"
            />
            <span className="note-label">Time:</span>
            <span className="note-value">{` @ ${getWorkspaceSlotTime(
              slotData?.start_time,
            )}`}</span>
          </div>
          {seaterPreference && (
            <div>
              <img
                src={acknowledgementStarIcon}
                alt="lets-do-it-logo"
                className="note-image"
              />
              <span className="note-label">Seater Preference:</span>
              <span className="note-credit-value">{` ${
                MEETING_ROOM_TYPE.find(
                  (room) => room.value === seaterPreference,
                )?.count
              } Seater.`}</span>
            </div>
          )}
          {slotData?.credits_required > 0 && (
            <div>
              <img
                src={acknowledgementStarIcon}
                alt="lets-do-it-logo"
                className="note-image"
              />
              <span className="note-label">Credit Required:</span>
              <span className="note-credit-value">{` ${slotData?.credits_required}`}</span>
            </div>
          )}
        </div>
        <div
          className="reserve-acknowledgement-dialog-do-it-button"
          onClick={onClickLetsDo}
        >
          {isLoading ? (
            <CircularProgress size={30} color="inherit" />
          ) : (
            <>
              <div>Let's Do It</div>
              <img src={letsDoItIcon} alt="lets-do-it-logo" className="image" />
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReserveAcknowledgementDialog;
